module.exports = __webpack_public_path__ + "img/ad2.ce82bc51.png";